// extracted by mini-css-extract-plugin
module.exports = {"root":"AddresseeItem_root__2X60G","inputCustom":"AddresseeItem_inputCustom__35vIP","item":"AddresseeItem_item__1ClyQ"};